import { useQuery } from "@tanstack/react-query";
import { ApiError } from "../../shared/api/errors.ts";
import { useApiClient } from "../../shared/session/SessionProvider.tsx";
import styles from "./Statistics.module.css";

export function Statistics() {
  const client = useApiClient();
  const query = useQuery({ queryKey: ["statistics"], refetchInterval: 30000, queryFn: async () => {
    const { data, error, response } = await client.GET("/v1/users/statistics");
    if (!data) throw ApiError.from(response, error);
    return data;
  } });
  return <section className={styles.statistics} aria-label="EVA в цифрах">
    <h2>EVA в цифрах</h2>
    <p>По всему сервису, за всё время</p>
    <div><strong>{query.data ? query.data.messagesSent.toLocaleString("ru") : "—"}</strong><span>Сообщений отправлено</span></div>
    <div><strong>{query.data ? query.data.cardsTotal.toLocaleString("ru") : "—"}</strong><span>Подключённых открыток</span></div>
    {query.isError && <button type="button" onClick={() => void query.refetch()}>Обновить статистику</button>}
  </section>;
}
